module.exports = __webpack_public_path__ + "media/images/analytics_icons/analytic_placement6-1765cba5f3aaca3731b690d40fef3f60.png";